export const ProfileForm = () => ({
  isFormValid: true,

  validationState: {
    name: { isValid: true },
    phone: { isValid: true },
    gender: { isValid: true },
    language: { isValid: true },
    currency: { isValid: true },
  },

  init() {
    this.validateForm()

    this.$el.addEventListener("phone-validation-changed", (event) => {
      this.handleValidationChange("phone", event.detail)
    })

    const nameInput = this.$el.querySelector('input[name="profile[name]"]')
    if (nameInput) {
      nameInput.addEventListener("input", () => {
        this.validateName(nameInput.value)
      })

      this.validateName(nameInput.value)
    }

    const genderInputs = this.$el.querySelectorAll('input[name="profile[gender]"]')
    if (genderInputs.length > 0) {
      genderInputs.forEach((input) => {
        input.addEventListener("change", () => {
          this.validateGender()
        })
      })

      this.validateGender()
    }

    const languageSelect = this.$el.querySelector('select[name="profile[language]"]')
    if (languageSelect) {
      languageSelect.addEventListener("change", () => {
        this.validateLanguage(languageSelect.value)
      })

      this.validateLanguage(languageSelect.value)
    }

    const currencySelect = this.$el.querySelector('select[name="profile[currency]"]')
    if (currencySelect) {
      currencySelect.addEventListener("change", () => {
        this.validateCurrency(currencySelect.value)
      })

      this.validateCurrency(currencySelect.value)
    }
  },

  handleValidationChange(fieldName, detail) {
    this.validationState[fieldName] = detail
    this.validateForm()
  },

  validateName(value) {
    const isValid = value && value.trim() !== ""
    this.validationState.name.isValid = isValid
    this.validateForm()
  },

  validateGender() {
    const genderInputs = this.$el.querySelectorAll('input[name="profile[gender]"]')
    const isValid = Array.from(genderInputs).some((input) => input.checked)
    this.validationState.gender.isValid = isValid
    this.validateForm()
  },

  validateLanguage(value) {
    const isValid = value && value.trim() !== ""
    this.validationState.language.isValid = isValid
    this.validateForm()
  },

  validateCurrency(value) {
    const isValid = value && value.trim() !== ""
    this.validationState.currency.isValid = isValid
    this.validateForm()
  },

  validateForm() {
    let allFieldsValid = true

    Object.values(this.validationState).forEach((state) => {
      if (!state.isValid) {
        allFieldsValid = false
      }
    })

    this.isFormValid = allFieldsValid
  },
})
